import React from 'react';

const BillingTransactionFormModal = React.lazy(() => import('../components/FormModal'));
const billingTransactionModalRegistry = {
    core_billingTransactionId: BillingTransactionFormModal
};
export default billingTransactionModalRegistry;
